import React from 'react';
import { Modal, Badge, Button, Table, Tag, Typography, Row, Col, notification } from 'antd';
import { CheckCircleOutlined,SyncOutlined, EuroCircleOutlined, CopyOutlined, CloseCircleOutlined } from '@ant-design/icons';
import '../../css/poolDetailsModal.css';
import cbgreenIcon from "../../assets/icons/pooling/cb-green.svg"; 
import cbredIcon from "../../assets/icons/pooling/cb-red.svg"; 
import euroCurrencyIcon from "../../assets/icons/pooling/euroCurrency.svg"; 
import { useSelector } from 'react-redux';
import ClipboardJS from 'clipboard';

const addThousandSeparator = (value) => {
  // Ensure the value is a valid number
  const number = parseFloat(value);

  if (isNaN(number)) {
    return ''; // Return an empty string for invalid input
  }

  // Format the number with thousand separators
  return number.toLocaleString('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 20, // Adjust to retain maximum precision if needed
  });
};



const PoolDetailsModal = ({ isVisible,poolStatus,poolType, onClose }) => {
  const { intiatedpoolingData } = useSelector((state) => state.pooling);
  console.log("poolDetailsDataDATA", intiatedpoolingData);
  const { user } = useSelector((state) => state.user);
  

  // Copy to Clipboard function
  const copyToClipboard = (text) => {
      // Create a temporary button for Clipboard.js to bind
      const tempButton = document.createElement('button');
      tempButton.style.opacity = '0'; // Hide the button
      tempButton.style.position = 'fixed'; // Prevent UI shift
      document.body.appendChild(tempButton);
    
      // Initialize Clipboard.js
      const clipboard = new ClipboardJS(tempButton, {
        text: () => text,
      });
    
      clipboard.on('success', () => {
        notification.success({
          message: 'Copied',
          description: 'The content has been copied to clipboard.',
        });
        clipboard.destroy();
        document.body.removeChild(tempButton);
      });
    
      clipboard.on('error', () => {
        notification.error({
          message: 'Copy failed',
          description: 'Failed to copy the content.',
        });
        clipboard.destroy();
        document.body.removeChild(tempButton);
      });
    
      // Programmatically trigger a click to activate Clipboard.js
      tempButton.click();
    };

  const columns = [
    {
      title: <span style={{ fontWeight: '400' }}>Token ID</span>,
      dataIndex: 'tokenId',
      key: 'tokenId',
      width: 160,
      render: (text) => (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {text}
          <CopyOutlined
            style={{ marginLeft: 8, cursor: 'pointer' }}
            onClick={() => copyToClipboard(text)} // Copy Token ID
          />
        </div>
      ),
    },
    {
      title: <span style={{ fontWeight: '400' }}>Vessel Name</span>,
      dataIndex: 'vesselName',
      key: 'vesselName',
      width: 110,
      render: (text, record) => (record.is_my_vessel ? text : <div style={{display:"flex",justifyContent:"center",alignItems:"center"}}>-</div>), // Show only if is_my_vessel is true
    },
    ...(user.role === "Admin Pooling Agent" ? [
      {
        title: <span style={{ fontWeight: '400' }}>Brokerage <br/>(%)</span>,
        dataIndex: 'brokerPercentage',
        key: 'brokerPercentage',
        width: 115,
        align: 'center',
      },
    ] : []),
    
    {
      title: <span style={{ fontWeight: '400' }}>Year</span>,
      dataIndex: 'year',
      key: 'year',
      align: 'center',
      width: 70,

    },
    {
      title: <span style={{ fontWeight: '400' }}>C.B. <br/> (MT CO<sub>2</sub>e)</span>,
      dataIndex: 'complianceBalance',
      key: 'complianceBalance',
      align: 'center',
      width: 150,
      render: (balance) => (
        <div style={{ display:'flex',
        justifyContent:'center',
        color: balance > 0 ? '#0CC876' : '#c80c0c' }}>
          {balance > 0 ? (
            <div style={{ display:"flex",alignItems:"center",justifyContent:"left" }}>
              {/* <img src={cbgreenIcon} alt="CB green" /> */}
              {addThousandSeparator(balance)} 
            </div>
          ) : (
            <div style={{ display:"flex",alignItems:"center",justifyContent:"left" }}>
              {/* <img src={cbredIcon} alt="CB red" /> */}
              {addThousandSeparator(balance)} 
            </div>
          )}
        </div>
      ),      
    },
    {
      title: <span style={{ fontWeight: '400' }}>Contribution <br/> (MT CO<sub>2</sub>e)</span>,
      dataIndex: 'contribution',
      key: 'contribution',
      align: 'center',
      width: 150,
      render: (balance) => (
        <div style={{ display:'flex',
        justifyContent:'center',
        color: balance >= 0 ? '#0CC876' : '#c80c0c' }}>
          {balance >= 0 ? (
            <div style={{ display:"flex",alignItems:"center",justifyContent:"left" }}>
              {/* <img src={cbgreenIcon} alt="CB green" /> */}
              {addThousandSeparator(balance)} 
            </div>
          ) : (
            <div style={{ display:"flex",alignItems:"center",justifyContent:"left" }}>
              {/* <img src={cbredIcon} alt="CB red" /> */}
              {addThousandSeparator(balance)} 
            </div>
          )}
        </div>
      ),      
    },
    {
      title: <span style={{ fontWeight: '400' }}>Remaining C.B. <br/>(MT CO<sub>2</sub>e)</span>,
      dataIndex: 'remainingCB',
      key: 'remainingCB',
      align: 'center',
      width: 150,
      render: (balance) => (
        <div style={{ display:'flex',
        justifyContent:'center',
        color: balance >= 0 ? '#0CC876' : '#c80c0c' }}>
          {balance >= 0 ? (
            <div style={{ display:"flex",alignItems:"center",justifyContent:"left" }}>
              {/* <img src={cbgreenIcon} alt="CB green" /> */}
              {addThousandSeparator(balance)} 
            </div>
          ) : (
            <div style={{ display:"flex",alignItems:"center",justifyContent:"left" }}>
              {/* <img src={cbredIcon} alt="CB red" /> */}
              {addThousandSeparator(balance)} 
            </div>
          )}
        </div>
      ),    
    },
    {
      title: <span style={{ fontWeight: '400' }}>Penalty <br/> (€)</span>,
      dataIndex: 'penalty',
      key: 'penalty',
      width: 100,
      align: 'center',
      render: (text) => (
        <div style={{ display:'flex',
          justifyContent:'center',
          alignItems:"center",
          color: parseFloat(text) > 0 ? '#c80c0c' : '#0CC876' }}>
            {parseFloat(text) > 0 ? (
              <div style={{ display:"flex",alignItems:"center",justifyContent:"center" }}>
                {addThousandSeparator(text)}
              </div>
            ) : (
              <div style={{ display:"flex",alignItems:"center",justifyContent:"center" }}>
                {addThousandSeparator(text)}
              </div>
            )}
          </div>
      ),
    },
    {
      title: <span style={{ fontWeight: '400' }}>GHGIE</span>,
      dataIndex: 'ghgIntensity',
      key: 'ghgIntensity',
      width: 80,
      align: 'center',
    },
    {
      title: <span style={{ fontWeight: '400' }}>PIC</span>,
      dataIndex: 'picName',
      key: 'picName',
      width: 100,
      render: (text, record) => (record.is_my_vessel ? text : <div style={{display:"flex",justifyContent:"center",alignItems:"center"}}>-</div>), // Show only if is_my_vessel is true
    },
    {
      title: <span style={{ fontWeight: 400 }}>Compensation <br/> (€) </span>,
      dataIndex: 'settledAt',
      key: 'settledAt',
      align: 'center',
      width: 130,
      render: (balance, row) => {
        if (!row.is_my_vessel) return '-';
        return (
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            color: row?.surplusDeficit == "surplus"? '#0CC876' : '#c80c0c'
          }}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
              {addThousandSeparator(Math.abs(balance))}
            </div>
          </div>
        );
      },
    },
    {
      title: <span style={{ fontWeight: '400' }}>Savings (€)</span>,
      dataIndex: 'savings',
      key: 'savings',
      align: 'center',
      width: 130,
      render: (balance, row) => {
        if (!row.is_my_vessel) return '-';
        return (
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            color: "#678DFF"
          }}>
            {addThousandSeparator(Math.abs(balance))}
          </div>
        );
      },
    },
    {
      title: <span style={{ fontWeight: '400' }}>Actions</span>,
      dataIndex: 'action',
      key: 'action',
      align: 'center',
      width: 95,
      render: (value) => (
        <Button
          style={{ color: '#678DFF' }}
          onClick={() => {
            // Code to trigger notification goes here
            notification.success({
              message: 'Notification sent',
              description: 'The notification has been successfully sent.',
            });
          }}
        >
          Notify
        </Button>
      ),
    }
      
  ];

  // Data source - combining surplus and deficit data
  const dataSource = [
    ...intiatedpoolingData.surplus.map((item, index) => ({
      key: `surplus-${index}`,
      tokenId: item.token_id,
      vesselName: item.vessel_name,
      brokerPercentage: item.broker_percentage,
      year: item.year,
      penalty: item.penalty,
      ghgIntensity: item.ghg_intensity,
      expectedPrice: item.expected_price_lv + " - " + item.expected_price_uv,
      picName: item.pic__name,
      complianceBalance: (Math.floor(item.compliance_balance / 10**6 * 1000000) / 1000000).toFixed(6),
      contribution: (Math.floor(item.contribution / 10**6 * 1000000) / 1000000).toFixed(6),
      remainingCB: (Math.trunc(item.compliance_balance-item.contribution / 10**6 * 1000000) / 1000000).toFixed(6),
      settledAt: (Math.floor(item.amount / 10**6 * 10000) / 10000).toFixed(4), // Assuming this represents the settled price
      savings:  (0).toFixed(4),
      surplusDeficit: 'surplus',
      is_my_vessel: item?.is_my_vessel,
    })),
    ...intiatedpoolingData.deficit.map((item, index) => ({
      key: `deficit-${index}`,
      tokenId: item.token_id,
      vesselName: item.vessel_name,
      brokerPercentage: item.broker_percentage,
      year: item.year,
      penalty: item.penalty,
      ghgIntensity: item.ghg_intensity,
      expectedPrice: item.expected_price_lv + " - " + item.expected_price_uv,
      picName: item.pic__name,
      complianceBalance: (Math.trunc(item.compliance_balance / 10**6 * 1000000) / 1000000).toFixed(6),
      contribution: (Math.floor(item.contribution / 10**6 * 1000000) / 1000000).toFixed(6),
      remainingCB: (Math.trunc(item.compliance_balance-item.contribution / 10**6 * 1000000) / 1000000).toFixed(6),
      settledAt: (Math.floor(item.amount / 10**6 * 10000) / 10000).toFixed(4),
      savings: (Math.round((parseFloat(item.penalty) - (parseFloat(item.amount) / 10**6)) * 10000) / 10000).toFixed(4)
 , // Assuming this represents the settled price
      surplusDeficit: 'deficit', // Added to identify deficit items
      is_my_vessel: item?.is_my_vessel,
    }))
    
  ];

  console.log("dataSource",dataSource[1])

  const handleCopyPoolId = () => {
    copyToClipboard(intiatedpoolingData.pool_id); // Copy Pool ID
  };

  const getRowClassName = (record) => {
    console.log("record",record)
    return record.surplusDeficit == 'surplus' ? 'surplus-row' : 'deficit-row';
  };

  return (
    <div className="pool-details-modal">
      <Modal
        onCancel={onClose}
        open={isVisible}
        width="100vw"
        centered
        className="pool-details-modal-antd z-1000"
        closable={true} // Adds the default close button (X)
        footer={null}  // Removes OK and Cancel buttons
      >
          <div className="modal-header">
            <Row justify="space-between" align="middle">
              <Col style={{ flex: 1 }}>
                <div>
                  <div strong>Pool Details ({intiatedpoolingData.total_vessels} Vessels)</div>
                </div>
                <div style={{display:"flex"}}>
                  {console.log("poolStatus",poolStatus)}
                  {poolStatus=="approved" || poolStatus=="Admin Approved" ? 
                      <Tag className="history-card-ant-tag" icon={<CheckCircleOutlined />} color="success">
                        Approved
                      </Tag>
                    : poolStatus=="Pending" || poolStatus=="Pending Admin" ?
                      <Tag className="history-card-ant-tag" icon={<SyncOutlined spin />} color="blue">
                        Pending
                      </Tag>
                    :
                      <Tag className="history-card-ant-tag" icon={<CloseCircleOutlined />} color="error">
                        Declined
                      </Tag>
                  }
                </div>

              </Col>
              {console.log("intiatedpoolingData",intiatedpoolingData)}
              <Col style={{ marginRight: '10px' }}>
                <div className={`total-cb-transasction ${intiatedpoolingData.total_cb_transaction >= 0 ? "green" : "red"}`}>
                  <img width={30} height={30} src={cbgreenIcon} />

                  {intiatedpoolingData.total_cb_transaction >= 0 ? "+" + addThousandSeparator(((Math.floor(intiatedpoolingData.total_cb_transaction * 1000000) / 1000000)).toFixed(6)) : addThousandSeparator(((Math.floor(intiatedpoolingData.total_cb_transaction * 1000000) / 1000000)).toFixed(6))} CB
                </div>
              </Col>
              {/* {poolType!="auto" ?
              <Col style={{ marginRight: '10px' }}>
                <div className='total-amount'>
                  <img width={30} height={30} src={euroCurrencyIcon} />
                  {addThousandSeparator(((Math.floor(intiatedpoolingData.settled_at * 10000) / 10000)).toFixed(4))}
                </div>
              </Col>:""} */}
              {/* <Col style={{ marginRight: '10px', display: 'flex', flexDirection: 'column', height: '100%' }}>
                <Button
                  style={{
                    backgroundColor: 'black',
                    color: 'white',
                    borderRadius: '15px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    flexGrow: 1, // This makes the button grow and fill the column height
                    height: '100%', // Ensure the button takes the full height of its parent
                    padding: '10px', // Add some padding if necessary
                  }}
                >
                  Download Report
                </Button>
              </Col> */}

            </Row>
          </div>


          <Table
            dataSource={dataSource}
            columns={columns}
            pagination={false}
            className="pool-details-table"
            scroll={{ y: 300 }}
            rowClassName={getRowClassName} // Apply conditional styling to rows
          />

          <div className="modal-footer">
            <div className="pool-id-container">
              <div>Pool ID: {intiatedpoolingData.pool_id}</div>
              <CopyOutlined
                style={{ marginLeft: 8, cursor: 'pointer' }}
                onClick={handleCopyPoolId} // Copy Pool ID
              />
            </div>
          </div>
      </Modal>
    </div>
  );
};

export default PoolDetailsModal;
